import { render, staticRenderFns } from "./Povesti.vue?vue&type=template&id=4acc3e62&scoped=true&"
import script from "./Povesti.vue?vue&type=script&lang=js&"
export * from "./Povesti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acc3e62",
  null
  
)

export default component.exports